import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ContentSearchResults",
    component: () =>
        __SERVER__ ? require("./content-search-results-view") : import("./content-search-results-view")
});

export default definition;
